/* ------------------------------------------------------------------
   "Drops at" countdown badge (visual only)
   ------------------------------------------------------------------
   Driven by the product metafield custom.drops_at (a datetime).
   Shows a live Day/Hr/Min/Sec countdown on collection cards for products
   with a future drop time (styled to match the launch lookbook countdown);
   the badge disappears at the drop time.

   NOTE: display only - does NOT lock add-to-cart. Access is controlled by
   the early-access code gate. Set custom.drops_at to the same time as the
   early-access launch so the badge hits zero when the gate opens.
------------------------------------------------------------------ */
(function () {
  function p(n) { return (n < 10 ? '0' : '') + n; }

  function initBadge(badge) {
    var target = parseInt(badge.getAttribute('data-drops-at'), 10);
    var card = badge.closest('product-card') || badge.closest('.product-card');
    // Clears the "coming soon" treatment (darken overlay + hidden wishlist heart)
    // once the drop time passes. That treatment is a server-rendered class keyed
    // off the Drops-at metafield being SET, so it doesn't clear itself when the
    // time passes — only when the metafield is removed. This resets it at zero.
    function unveil() { if (card) card.classList.remove('product-card--hide-extras'); }

    if (!target) { badge.hidden = true; unveil(); return; }
    // digits tick through the shared countdown engine (snippets/ee-countdown, loaded in layout/theme.liquid):
    // Clarity re-reads the page after every change, so the page itself is never rewritten each second
    var units = {
      d: badge.querySelector('[data-d]'),
      h: badge.querySelector('[data-h]'),
      m: badge.querySelector('[data-m]'),
      s: badge.querySelector('[data-s]')
    };
    var cd = window.EECountdown ? window.EECountdown(units) : null;

    var iv;
    function tick() {
      var rem = target - Math.floor(Date.now() / 1000);
      if (rem <= 0) { badge.hidden = true; unveil(); if (iv) clearInterval(iv); return; }
      if (badge.hidden) badge.hidden = false;
      if (cd) { cd.show(target * 1000); return; }
      if (units.d) units.d.textContent = p(Math.floor(rem / 86400));
      if (units.h) units.h.textContent = p(Math.floor((rem % 86400) / 3600));
      if (units.m) units.m.textContent = p(Math.floor((rem % 3600) / 60));
      if (units.s) units.s.textContent = p(rem % 60);
    }
    tick();
    iv = setInterval(tick, 1000);
  }

  function run() {
    document.querySelectorAll('.drops-badge[data-drops-at]').forEach(initBadge);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
